<template>
  <section>
    <header>
      <h1 class="page-header">About</h1>
    </header>
    <h3>What is Six Plus Hold’em?</h3>
    <p>
      Six Plus Hold’em is an app that makes it easier to study poker. Check
      out the playlists below:
    </p>
    <section class="embed-responsive embed-responsive-16by9">
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8vRDnCZ_h1XsBar-k190Bs"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </section>
    <br />
    <section class="embed-responsive embed-responsive-16by9">
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8rhfjlwM7OFsq_1YDfJNCf"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </section>
    <h3>Who is behind Six Plus Hold’em?</h3>
    <p>
      Me! My name is Adam Zerner. I'm 26 years old and live in Summerlin, Las
      Vegas with my girlfriend and dog. I guess I'd call myself a serial
      entrepreneur. I plan on starting startups throughout my life, and this is
      my second one. Before Six Plus Hold’em I worked as a programmer,
      started a startup called College Inside View, and got my degree in
      neuroscience at Pitt.
    </p>
    <h3>What's the story behind Six Plus Hold’em?</h3>
    <p>
      After working as a programmer for two years, I had taken a year off to
      self-study computer science. At the end of the year, I wanted to freelance
      a bit to save up some more money before starting a startup. But my web
      development skills had gotten rusty after focusing so much on computer
      science, so I needed a project to dust off the rust.
    </p>
    <p>
      When I was looking for a project, I thought back to Flopzilla and Equilab.
      I wanted to download them a few months back, but I wasn't able to because
      I'm a Mac user. So I figured that for my project, I'd build myself a basic
      version of those apps.
    </p>
    <p>
      Well, that project turned in to Six Plus Hold’em. I was having a really
      good time working on it and I started realizing that it could be better
      than the existing apps out there. That's when it turned in to my full time
      pursuit.
    </p>
  </section>
</template>

<script>
export default {
  name: "ppt-about"
};
</script>

<style lang="scss" scoped>
section {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue